import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import loadable from '@loadable/component';
import MobileNavbarLink from 'components/nav/MobileNavbarModal/components/MobileNavbarLink';
import IconArrow from 'components/icons/iconArrowRightSimple';
import useRandomId from 'hooks/useRandomId';
const AnimateHeight = loadable(() => import('react-animate-height'));
const MobileNavbarExpandableCategory = t0 => {
  const $ = _c(33);
  const {
    items: t1,
    categoryLabel,
    categoryId,
    color,
    openCategoryId,
    setOpenCategoryId
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const items = t2;
  const isOpen = openCategoryId === categoryId;
  const elementId = useRandomId(`mobilenavbar-category-${categoryId}-`);
  let t3;
  if ($[2] !== categoryId || $[3] !== isOpen || $[4] !== setOpenCategoryId) {
    t3 = () => {
      if (isOpen) {
        setOpenCategoryId(null);
      } else {
        setOpenCategoryId(categoryId);
      }
    };
    $[2] = categoryId;
    $[3] = isOpen;
    $[4] = setOpenCategoryId;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = `Toggle ${categoryLabel} category`;
  const t5 = color === "red";
  let t6;
  if ($[6] !== t5) {
    t6 = classNames("MobileNavbarExpandableCategory__button-text", {
      "text-red": t5
    });
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== categoryLabel || $[9] !== t6) {
    t7 = <span className={t6}>{categoryLabel}</span>;
    $[8] = categoryLabel;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== isOpen) {
    t8 = classNames("transition-[transform_.2s_ease]", {
      "rotate-90": isOpen
    });
    $[11] = isOpen;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t8) {
    t9 = <IconArrow className={t8} width="8" height="15" />;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== elementId || $[16] !== isOpen || $[17] !== t3 || $[18] !== t4 || $[19] !== t7 || $[20] !== t9) {
    t10 = <button className="text-lg items-center [background:none] border-0 !text-gray flex justify-between px-5 py-3 text-left no-underline w-full hover:underline focus-visible:rounded-[3px] focus-visible:outline-offset-[-4px]" type="button" onClick={t3} aria-label={t4} aria-controls={elementId} aria-expanded={isOpen}>{t7}{t9}</button>;
    $[15] = elementId;
    $[16] = isOpen;
    $[17] = t3;
    $[18] = t4;
    $[19] = t7;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  const t11 = isOpen ? "auto" : 0;
  let t12;
  if ($[22] !== items) {
    t12 = items.map(_temp);
    $[22] = items;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t12) {
    t13 = <div className="MobileNavbarExpandableCategory__items">{t12}</div>;
    $[24] = t12;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== elementId || $[27] !== t11 || $[28] !== t13) {
    t14 = <AnimateHeight duration={200} height={t11} id={elementId}>{t13}</AnimateHeight>;
    $[26] = elementId;
    $[27] = t11;
    $[28] = t13;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== t10 || $[31] !== t14) {
    t15 = <div className="MobileNavbarExpandableCategory">{t10}{t14}</div>;
    $[30] = t10;
    $[31] = t14;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  return t15;
};
MobileNavbarExpandableCategory.propTypes = {
  color: PropTypes.oneOf(['gray', 'red']),
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.node,
    to: PropTypes.string
  })),
  categoryId: PropTypes.string.isRequired,
  categoryLabel: PropTypes.string.isRequired,
  openCategoryId: PropTypes.string,
  setOpenCategoryId: PropTypes.func
};
export default MobileNavbarExpandableCategory;
function _temp(t0) {
  const {
    id,
    label,
    to
  } = t0;
  return <MobileNavbarLink key={id} to={to} isNested={true}>{label}</MobileNavbarLink>;
}